export enum BACKGROUND_CREDIT_CHECK_PROVIDER {
  TU_SMARTMOVE = "TU_SMARTMOVE",
  TU_SHAREABLE = "TU_SHAREABLE",
  EXPERIAN_CONSUMER_CONNECT = "EXPERIAN_CONSUMER_CONNECT",
}
